import Axios from "axios";
import React, { useContext } from "react";
import { Link } from "react-router-dom";
import UserContext from "../../context/UserContext";
import domain from "../../util/domain";
import "./Navbar.scss";

function Navbar() {
  const { user, getUser } = useContext(UserContext);

  async function logOut() {
    await Axios.get(`${domain}/auth/logOut`);
    await getUser();
  }

  return (
    <div className="navbar">
      <Link to="/">
        <h1 className="title">Case Manager</h1>
      </Link>
      {user === null ? (
        <>
          <Link to="/login">Log in</Link>
          {/* <Link to="/register">Register</Link> */}
          <Link to="/dashboard-demo">Dashboard Demo</Link>
        </>
      ) : (
        user && (
          <>
          <Link to="/dashboard">Dashboard</Link>
          <Link to="/tools">Tools</Link>
          <button className="btn-logout" onClick={logOut}>
            Log out
          </button>
          </>
        )
      )}
    </div>
  );
}

export default Navbar;